import { styled } from 'stitches.config'

export const HowToFeedSafelyRoot = styled('div', {
  width: '100%',
  background: '$accent-white',
  padding: '64px 0px',

  '@bp2': {
    padding: '77px 0px',
  },

  '& .copy-col ul, & .copy-col ol': {
  listStyle: 'disc outside', 
  paddingLeft: '1.5rem'  ,
  marginBottom: '1rem'
},

'& .copy-col li': {
  display: 'list-item',
  listStyleType: 'disc'
},

})

export const Header = styled('h2', {
  fontSize: '$h3',
  letterSpacing: '$h3',
  lineHeight: '$h3',
  textAlign: 'center',
  margin: 'auto',
  marginBottom: '24px',
  '@bp2': {
    fontSize: '$h1',
    letterSpacing: '$h1',
    lineHeight: '$h1',
    marginBottom: '42px',
  },
})

export const HowToFeedSafelyContainer = styled('div', {})
export const ButtonWrapper = styled('div', {
  marginTop: '42px',
  display: 'flex',
  justifyContent: 'center',
  '@bp2': {
    justifyContent: 'center',
  },
})
